export function GalleryStudioLoading() {
  return (
    <div className="space-y-3" aria-label="Loading Gallery Studio">
      <div className="h-20 animate-pulse rounded-xl bg-muted/60" />

      <div className="h-44 animate-pulse rounded-xl bg-muted/60" />
    </div>
  )
}
